import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
// import { FormCheck } from 'react-bootstrap';
import { Form, Badge } from 'react-bootstrap';

import { Card, CardBody } from '@components/card/card';
import styles from './style.module.css';

function ListView({ app, onStatusChange, isSubmitting }: { app: any; onStatusChange: any; isSubmitting: boolean }) {
  const { i18n, t } = useTranslation();

  return (
    <>
      {/* {app.map((app: any) => ( */}
      <Card className={`rounded-2 mb-2 p-3 bg-body  ${styles.cardHoverEffect}`}>
        <CardBody className='p-0'>
          <div>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <div
                  className='me-3 bg-theme bg-opacity-15 shadow  rounded-2 shadow d-flex justify-content-center align-items-center'
                  style={{ width: '50px', height: '50px' }}
                >
                  <Icon
                    className='iconify   '
                    icon={app.icon}
                    width='35'
                    height='35'
                    style={{ color: app.color }}
                    aria-label={app.name + ' icon'}
                  />
                </div>

                <div>
                  <div className='h6'>
                    {app.name}
                    <Badge bg={app.isActive ? 'success' : 'secondary'} className='text-dark ms-2'>
                      {app.isActive === true ? t('IsActive') : t('InActive')}
                    </Badge>
                  </div>

                  <span className='text-muted fs-12px'>
                    {i18n.language === 'en' ? app.description : app.description2}
                  </span>
                </div>
              </div>

              {isSubmitting ? (
                <div className='spinner-grow spinner-grow-sm text-theme'></div>
              ) : (
                <Form.Check
                  className={styles.switchHidden}
                  type='switch'
                  id={`custom-switch-${app.id}`}
                  checked={app.isActive}
                  onChange={() => onStatusChange(app.id, !app.isActive)}
                />
              )}

              {/* <FormCheck type='switch' className={styles.switchHidden} id='analytics-switch' label='' /> */}
            </div>
          </div>
        </CardBody>
      </Card>
      {/* // ))} */}
    </>
  );
}

export default ListView;

// <ListGroup.Item key={app.id} className='d-flex justify-content-between align-items-center'>
// <Icon
//   className='iconify me-2'
//   icon={app.icon}
//   width='25'
//   height='25'
//   style={{ color: app.color }}
//   aria-label={app.name + ' icon'}
// />
//   <div>
//     <div className='h6 mb-1'>{app.name}</div>
//     <div className='text-muted fs-12px'>{i18n.language === 'en' ? app.description : app.description2}</div>
//   </div>
//   <div>
//     <Form.Check type='switch' id={`custom-switch-${app.id}`} checked={app.active} readOnly />
//   </div>
// </ListGroup.Item>
